import axios from "axios";
/**
* Bug #452
* @Author Santhosh Kumar
* @Date 21 June 2021
*/
import { API_PATIENT_REGISTER, API_PATIENT_ACTIVATION, API_REGISTER_USER_FROM_APPT } from 'api/endpoint';

export const registerUser = (data) => {
  //console.log(data);
  return axios.post(API_PATIENT_REGISTER, data);
};

export const activateUser = (data) => {
  //console.log(data);
  return axios.post(API_PATIENT_ACTIVATION, data);
};
/*** End ***/

/** Bug #782 appointmnet reminder @Author Jithin Kuriakose  @date: 25Mar2022 */
export const regUserFromAppt = (data) => {
  //console.log(data);
  return axios.post(API_REGISTER_USER_FROM_APPT, data);
};
//End Bug #782